// enumerates query params that triggers IDA to open upon loading
// ie. Intelligent Alerts emails
export enum CustomerDeliverabilityEngineQueryParams {
  CDE_ERROR_CODE = "cdeErrorCode",
  CDE_ERROR_CODE_NAME = "cdeErrorCodeName",
}

export enum IntelligentAssistantEvents {
  SESSION_STORAGE_CHANGE = "intelligentAssistantSessionStorageChanged",
}

// session storage keys used by IDA
export enum IntelligentAssistantSession {
  CURRENT_ACCOUNT_SID = "intelligentAssistantCurrentAccountSid",
  CURRENT_SESSION_KEY = "intelligentAssistantSession",
  CURRENT_EXTERNAL_PROMPT_KEY = "intelligentAssistantExternalPrompt",
}

export enum CDEBetaFeatures {
  INTELLIGENT_DISCOVERY_ASSISTANT_ENABLED = "cde-intelligent-discovery-assistant-ux",
  INTELLIGENT_DISCOVERY_ASSISTANT_INTELLIGENT_ALERTS_ENABLED = "messaging.insights.intelligent-alerts.beta",
  INTELLIGENT_DISCOVERY_ASSISTANT_LOGS_ENABLED = "cde-logs-intelligent-discovery-assistant-ux",
  INTELLIGENT_DISCOVERY_ASSISTANT_INSIGHTS_ALWAYS_ON = "cde-insights-intelligent-discovery-assistant-always-on",
  DELIVERABILITY_SCORE_ENABLED = "cde-deliverability-score-ux",
}

// triggers that are external to IDA+WO that can open IDA as a side panel
export enum CDEExternalPromptButtons {
  TROUBLESHOOT_MESSAGE_SID = "troubleshootMessageSid",
  TROUBLESHOOT_ERROR_CODE = "troubleshootErrorCode",
}
